var CreateApplicationDetailsTpamsComponent_1;
import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-tpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-tpams.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { CreateApplicationDetailsTpamsConstants } from "./create-application-details-tpams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
export let CreateApplicationDetailsTpamsComponent = class CreateApplicationDetailsTpamsComponent extends CreateApplicationViewBaseComponent {
    static { CreateApplicationDetailsTpamsComponent_1 = this; }
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appControllerService;
    changeDetectorRef;
    // form controls
    detailsFormControlName = CreateApplicationDetailsTpamsConstants.DETAILS_FORM_CONTROL_NAME;
    descriptionFormControlName = CreateApplicationDetailsTpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    referenceNumberControlName = CreateApplicationDetailsTpamsConstants.REFERENCE_NUMBER_CONTROL_NAME;
    amendmentSchemeNumberFormControlName = CreateApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_FORM_CONTROL_NAME;
    applicationTypesFormControlName = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPES_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    zonesFormControlName = CreateApplicationDetailsTpamsConstants.ZONES_FORM_CONTROL_NAME;
    zoneFormControlName = CreateApplicationDetailsTpamsConstants.ZONE_FORM_CONTROL_NAME;
    // labels
    addApplicationTypeLabel = CreateApplicationDetailsTpamsConstants.ADD_APPLICATION_TYPE_LABEL;
    addZoneLabel = CreateApplicationDetailsTpamsConstants.ADD_ZONE_LABEL;
    removeLabel = SharedConstants.REMOVE_LABEL;
    applicationTypeLabel = CreateApplicationDetailsTpamsConstants.APPLICATION_TYPE_LABEL;
    zoneLabel = CreateApplicationDetailsTpamsConstants.ZONE_LABEL;
    descriptionLabel = CreateApplicationDetailsTpamsConstants.DESCRIPTION_LABEL;
    amendmentSchemeNumberLabel = CreateApplicationDetailsTpamsConstants.AMENDMENT_SCHEME_NUMBER_LABEL;
    referenceNumberLabel = CreateApplicationDetailsTpamsConstants.REFERENCE_NUMBER_LABEL;
    validationMessages = CreateApplicationDetailsTpamsConstants.VALIDATION_MESSAGES;
    applicationTypeLookupName = SharedConstants.APPLICATION_TYPE_LOOKUP_NAME;
    zoningLookupName = SharedConstants.ZONING_LOOKUP_NAME;
    detailsForm;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    applicationTypes = [];
    zones = [];
    showRefNumber = false;
    fullApplicationCheckRequired = false;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appControllerService, changeDetectorRef) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appControllerService = appControllerService;
        this.changeDetectorRef = changeDetectorRef;
    }
    static removeControlsByIndex(controls, index) {
        if (controls.controls.length > 1) {
            controls.removeAt(index);
        }
    }
    static setControlValue(formGroup, controlName, value, disableControl = false) {
        const formControl = formGroup.get(controlName);
        formControl.setValue(value);
        if (disableControl) {
            formControl.disable();
        }
    }
    ngOnInit() {
        this.initForm();
        this.getApplicationTypeAndZoningLookups();
    }
    loadMetadata(stepMeta) {
        // step does not use metadata
    }
    getApplicationTypes() {
        return this.detailsForm.get(this.applicationTypesFormControlName);
    }
    onBtnRemoveApplicationTypeClicked(i) {
        const controls = this.getApplicationTypes();
        CreateApplicationDetailsTpamsComponent_1.removeControlsByIndex(controls, i);
    }
    getZones() {
        return this.detailsForm.get(this.zonesFormControlName);
    }
    onBtnRemoveZoneClicked(i) {
        const controls = this.getZones();
        CreateApplicationDetailsTpamsComponent_1.removeControlsByIndex(controls, i);
    }
    onBtnAddApplicationTypeClicked() {
        const applicationTypesControl = this.getApplicationTypes();
        const typeGroup = new FormGroup({
            type: new FormControl(null, [Validators.required])
        });
        applicationTypesControl.push(typeGroup);
    }
    onBtnAddZoneClicked() {
        const zonesControl = this.getZones();
        const zoneGroup = new FormGroup({
            zone: new FormControl(null, [Validators.required])
        });
        zonesControl.push(zoneGroup);
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.detailsFormControlName);
    }
    getApplicationTypeAndZoningLookups() {
        const filterString = `moduleId eq ${this.appControllerService.selectedModuleID} and (name eq '${this.applicationTypeLookupName}' or name eq '${this.zoningLookupName}')`;
        const params = {
            $filter: filterString,
        };
        this.applicationCreateService.getLookupsObservable(params).subscribe({
            next: (response) => {
                this.onGetLookupsCompleted(response);
            },
            error: (error) => {
                this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsTpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
            }
        });
    }
    onGetLookupsCompleted(response) {
        this.applicationTypes = [];
        this.zones = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === this.applicationTypeLookupName) {
                    this.applicationTypes.push(JSON.parse(item.content));
                }
                if (item.name === this.zoningLookupName) {
                    this.zones.push(JSON.parse(item.content));
                }
            });
            this.sortZoneDropDownAlphabetically();
            this.sortApplicationTypesAlphabetically();
            this.changeDetectorRef.markForCheck();
            this.subscribeToSelectedApplication();
        }
    }
    subscribeToSelectedApplication() {
        this.cleanupAfterDestroy(this.selectedApplicationService.$selectedApplication).subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        if (application.referenceNumber) {
            this.showRefNumber = true;
            this.detailsForm.get(this.referenceNumberControlName).enable();
            CreateApplicationDetailsTpamsComponent_1.setControlValue(this.detailsForm, this.referenceNumberControlName, application.referenceNumber, true);
        }
        else {
            this.showRefNumber = false;
        }
        if (application.description) {
            CreateApplicationDetailsTpamsComponent_1.setControlValue(this.detailsForm, this.descriptionFormControlName, application.description);
        }
        else {
            this.detailsForm.get(this.descriptionFormControlName).enable();
        }
        if (application.amendmentSchemeNumber) {
            CreateApplicationDetailsTpamsComponent_1.setControlValue(this.detailsForm, this.amendmentSchemeNumberFormControlName, application.amendmentSchemeNumber);
        }
        else {
            this.detailsForm.get(this.amendmentSchemeNumberFormControlName).enable();
        }
        if (application.applicationTypes && application.applicationTypes.length > 0) {
            const appTypes = application.applicationTypes;
            this.setTypes(appTypes);
        }
        if (application.applicationZonings && application.applicationZonings.length > 0) {
            const appZones = application.applicationZonings;
            this.setZones(appZones);
        }
    }
    setTypes(appTypes) {
        const typesControl = this.getApplicationTypes();
        typesControl.clear();
        // sets application types from the application
        appTypes.forEach(applicationType => {
            let appType = null;
            this.applicationTypes.forEach(item => {
                if (item.value === applicationType.applicationType) {
                    appType = item;
                }
            });
            const typeGroup = new FormGroup({
                id: new FormControl(applicationType.id),
                applicationId: new FormControl(applicationType.applicationId),
                type: new FormControl(appType, Validators.min(1)),
                jobId: new FormControl(this.jobId)
            });
            typesControl.push(typeGroup);
        });
    }
    setZones(appZones) {
        const zonesControl = this.getZones();
        zonesControl.clear();
        appZones.forEach(applicationZoning => {
            let zone = null;
            this.zones.forEach(item => {
                if (item.value === applicationZoning.zoning) {
                    zone = item;
                }
            });
            const zoneGroup = new FormGroup({
                id: new FormControl(applicationZoning.id),
                applicationId: new FormControl(applicationZoning.applicationId),
                applicationPropertyId: new FormControl(applicationZoning.applicationPropertyId),
                zone: new FormControl(zone, Validators.min(1)),
                jobId: new FormControl(this.jobId)
            });
            zonesControl.push(zoneGroup);
        });
    }
    sortZoneDropDownAlphabetically() {
        if (this.zones.length > 0) {
            this.zones.sort((a, b) => (a.value?.localeCompare(b?.value)));
        }
    }
    sortApplicationTypesAlphabetically() {
        if (this.applicationTypes.length > 0) {
            this.applicationTypes.sort((a, b) => (a.value?.localeCompare(b?.value)));
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef }
    ];
};
CreateApplicationDetailsTpamsComponent = CreateApplicationDetailsTpamsComponent_1 = __decorate([
    Component({
        selector: "app-create-application-details-tpams",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsTpamsComponent);
